import { useEffect, useEffectEvent } from 'react'
import type { ShortcutMap } from './use-keyboard-shortcut.types'
export type { ShortcutEvent, ShortcutMap } from './use-keyboard-shortcut.types'

export function useKeyboardShortcut(map: ShortcutMap) {
  const dispatch = useEffectEvent((event: KeyboardEvent) => {
    const target = event.target
    const input = target instanceof HTMLInputElement
    map[event.key.toLowerCase()]?.({
      key: event.key,
      altKey: event.altKey,
      ctrlKey: event.ctrlKey,
      metaKey: event.metaKey,
      shiftKey: event.shiftKey,
      defaultPrevented: event.defaultPrevented,
      textEntry: target instanceof HTMLElement && (target.isContentEditable || input || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement),
      singleLineAnswer: input && target.type !== 'checkbox' && target.type !== 'radio',
      button: target instanceof Element && !!target.closest('button'),
      preventDefault: () => { event.preventDefault() },
    })
  })
  useEffect(() => {
    window.addEventListener('keydown', dispatch)
    return () => { window.removeEventListener('keydown', dispatch) }
  }, [])
}
